// API des études Brésil / États-Unis — /api/etude_import/:pays/* (routes/etude_import.js), publique.
// o = ISO3 du pays d'origine (filtre de toute l'étude, sauf classement des origines et position mondiale).
import type { Pays } from './pays';

export interface YearInfo { ano: number; max_mes: number; v: number }
export interface Origin { iso3: string; iso2: string | null; country_es: string | null; country_en: string | null; country_fr: string | null; flag_url: string | null; raw: string | null; v: number }
export interface Meta { pays: string; years: YearInfo[]; min_year: number; max_year: number; latest_complete_year: number; origins: Origin[] }

export interface MonthRow { ano: number; mes: number; v: number; l: number }
export interface CodeRow { ano: number; mes: number; code: string; hs6: string; v: number; l: number }
export interface OrigRow { iso3: string; v: number; l: number }
export interface OrigTs { ano: number; iso3: string; v: number; l: number }
export interface SparkRow { iso3: string; code: string; v: number; l: number }
export interface RegRow { r: string; v: number; l: number }
export interface RegTs { ano: number; r: string; v: number }
export interface RegOrig { r: string; iso3: string; v: number }
export interface ViaRow { via: string; v: number; cif: number; flete: number; l: number }
export interface PortRow { urf: string; via: string; v: number; l: number }
export interface Bundle {
  pays: string; ano: number; mm: number; o: string | null;
  monthly: MonthRow[]; codes: CodeRow[];
  origins: { cur: OrigRow[]; prev: OrigRow[] }; originsTs: OrigTs[];
  spark: { cur: SparkRow[]; prev: SparkRow[] };
  regions: { cur: RegRow[]; prev: RegRow[] }; regionsTs: RegTs[]; regionOrigins: RegOrig[];
  via?: { cur: ViaRow[]; prev: ViaRow[]; origins: { via: string; iso3: string; v: number }[] };
  ports?: PortRow[];
}
export interface WorldImp { iso3: string; v: number; l: number; rank: number; rank_volume: number; share_pct: number; price_l: number | null }
export interface World {
  ano: number; requested: number | null; fallback: boolean;
  world: { v: number; l: number; price_l: number | null; n: number };
  me: { rank: number; rank_volume: number; share_pct: number; v: number; l: number; price_l: number | null } | null;
  importers: WorldImp[];
  suppliers: { iso3: string; to_c: number; exports: number | null; share_pct: number | null }[];
  names: { iso3: string; iso2: string | null; country_es: string | null; country_en: string | null; country_fr: string | null }[];
}

type Q = Record<string, string | number | null | undefined>;
const qs = (o: Q) => new URLSearchParams(Object.entries(o).filter(([, v]) => v != null && v !== '').map(([k, v]) => [k, String(v)])).toString();
async function get<T>(p: Pays, path: string, q: Q = {}): Promise<T> {
  const s = qs(q);
  const r = await fetch(`/api/etude_import/${p}/${path}${s ? '?' + s : ''}`, { credentials: 'same-origin' });
  if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + path);
  return r.json() as Promise<T>;
}

export const fetchMeta = (p: Pays) => get<Meta>(p, 'meta');
export const fetchBundle = (p: Pays, ano: number, o?: string) => get<Bundle>(p, 'bundle', { ano, o });
export const fetchWorld = (p: Pays, ano: number) => get<World | null>(p, 'world', { ano });
